<template>
<div id="main-content" class="taskboard">
  <div class="container-fluid">
    <div class="block-header">
      <div class="row">
        <div class="col-lg-6 col-md-8 col-sm-12">
          <h2><a href="javascript:void(0);" class="btn btn-xs btn-link btn-toggle-fullwidth"><i class="fa fa-arrow-left"></i></a> Tickets</h2>
          <ul class="breadcrumb">
            <li class="breadcrumb-item"><a href="index.html"><i class="icon-home"></i></a></li>                            
            <li class="breadcrumb-item">Apps</li>
            <li class="breadcrumb-item active">Tickets</li>
          </ul>
        </div>
      </div>
    </div>
    <div class="row clearfix">
      <div class="col-lg-12 col-md-12">
        <div class="card">
          <div class="header">
            <h2>Member Management Detail</h2>
          </div>
          <div class="body">
            <div class="row">
              <div class="form-group col-3">
                <label>First Name</label>
                <input type="text" class="form-control" disabled v-model="mm.firstName" id="firstName" aria-describedby="action">
              </div>
              <div class="form-group col-3">
                <label>Last Name</label>
                <input type="text" class="form-control" disabled v-model="mm.lastName" id="lastName" aria-describedby="action">
              </div>
              <div class="form-group col-3">
                <label for="module">Email</label>
                <input type="text" class="form-control" disabled v-model="mm.email" id="email" aria-describedby="module">
              </div>
            </div>
            <div class="row">
              <div class="form-group col-3">
                <label for="role">Department</label>
                <app-dropdown :id="'departmentName'" :keyName="'departmentName'" :model="mm.departmentName" :lists="departmentList" :title="'name'" :value="'id'" v-on:selectedChanged="selectChange"></app-dropdown>
              </div>
              <div v-if="this.mmRole === 'admin'" class="form-group col-3">
                <label for="role">Area</label>
                <app-dropdown :id="'areaName'" :keyName="'areaName'" :model="mm.areaName" :lists="areaList" :title="'name'" :value="'id'" v-on:selectedChanged="selectChange"></app-dropdown>
              </div>
              <div v-if="this.mmRole === 'admin'" class="form-group col-3">
                <label for="role">Role</label>
                <app-dropdown :id="'role'" :keyName="'role'" :model="mm.role" :lists="roleList" :title="'name'" :value="'id'" v-on:selectedChanged="selectChange"></app-dropdown>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-3">
                <label>Verify By Member</label>
                <input type="checkbox" class="form-control" disabled v-model="mm.isVerifiedEmail" id="isVerifiedMember">
              </div>
              <div class="form-group col-3">
                <label>Verify by Admin</label>
                <input type="checkbox" class="form-control" v-model="mm.isVerified" id="isVerified">
              </div>
              <div class="form-group col-3">
                <label>Active</label>
                <input type="checkbox" class="form-control" v-model="mm.isActive" id="isActive">
              </div>
            </div>
            <button type="button" class="btn btn-outline-success" @click="save">Save <i class="far fa-save"></i></button>
            <button type="button" class="btn btn-outline-danger" @click="cancel">Close Page <i class="far fa-window-close"></i></button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import Vue from 'vue'
import api from '../services/api'
import { memberManagement } from '../models/memberManagement'
import { prettifyErrorMessage } from '../utils'
import AppDropdown from '../components/AppDropdown.vue'

export default {
  components: {
    AppDropdown
  },
  data() {
    return {
      mm: {
        ...memberManagement
      },
      departmentList: [],
      areaList: [],
      listErr: [],
      mmRole: '',
      roleList: []
    }
  },
  async created() {
    const departmentApi = api('department')
    this.departmentList = await departmentApi.get()

    const areaApi = api('area')
    this.areaList = await areaApi.get()

    const roleApi = api('member-management/role')
    this.roleList = await roleApi.get()

    if(this.$route.query.id !== undefined) {
      const mmApi = api('member-management/detail')
      const mmResult = await mmApi.getWithParams(this.$route.query.id)
      this.mm = mmResult[0]
      this.mmRole = mmResult[1]
    }
  },
  methods: {
    async save() {
      this.validate()

      if(this.listErr.length > 0) {
        this.showValidationError()
        return
      }
      const mmApi = api('member-management')
      await mmApi.update(this.mm, this.$route.query.id)
      this.$router.go(-1)
    },
    cancel() {
      this.$router.go(-1)
    },
    selectChange(data) {
      const currentData = this.mm
      this.mm = {
        ...currentData,
        ...data
      }
    },
    showValidationError() {
      Vue.notify({
        group: 'appNotif',
        title: 'Validation errors',
        text: prettifyErrorMessage(this.listErr),
        type: 'error'
      })
    },
    validate() {
      // if(this.td.assignedTo === '') this.listErr.splice(this.listErr.length, 0, 'Please choose which department to assign task')
    },
  }
}
</script>